import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaArrowLeft, FaPlus, FaTrash, FaUtensils, FaListUl, FaEdit, FaImage, FaTimes, FaCheckCircle, FaSave } from 'react-icons/fa';

export default function Productos({ sucursalId, goBack }) {
    const [productos, setProductos] = useState([]);
    const [insumos, setInsumos] = useState([]); 
    const [showModal, setShowModal] = useState(false);
    const [showReceta, setShowReceta] = useState(false);
    
    // --- NUEVOS ESTADOS PARA EDICIÓN ---
    const [modalMode, setModalMode] = useState('add'); // 'add' o 'edit'
    const [editId, setEditId] = useState(null);

    // Estados Receta
    const [selectedProd, setSelectedProd] = useState(null);
    const [recetaItems, setRecetaItems] = useState([]);
    const [ingredienteForm, setIngredienteForm] = useState({ insumo_id: '', cantidad: '' });

    // Estado Formulario
    const [formData, setFormData] = useState({ nombre: '', descripcion: '', precio: '', imagen: null });
    const [imagePreview, setImagePreview] = useState(null);

    useEffect(() => {
        fetchProductos();
        fetchInsumos();
    }, [sucursalId]);

    const fetchProductos = async () => {
        try {
            const res = await axios.get(`https://api.alquilacarbolivia.com/api/productos/${sucursalId}`);
            setProductos(res.data);
        } catch (error) { console.error(error); }
    };
    
    const fetchInsumos = async () => {
        try {
            const res = await axios.get(`https://api.alquilacarbolivia.com/api/inventario/${sucursalId}`);
            setInsumos(res.data);
        } catch (error) { console.error(error); }
    };

    // --- FUNCIÓN PARA ABRIR EDICIÓN ---
    const handleEditClick = (prod) => {
        setModalMode('edit');
        setEditId(prod.id);
        setFormData({
            nombre: prod.nombre,
            descripcion: prod.descripcion || '',
            precio: prod.precio,
            imagen: null // Se deja en null a menos que elija una nueva
        });
        setImagePreview(prod.imagen_url); // Mostrar la foto actual
        setShowModal(true);
    };

    // --- GUARDAR (CREAR O EDITAR) ---
    const handleSaveProducto = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('sucursal_id', sucursalId);
        data.append('nombre', formData.nombre);
        data.append('descripcion', formData.descripcion);
        data.append('precio', formData.precio);
        if (formData.imagen) data.append('imagen', formData.imagen);

        try {
            if (modalMode === 'add') {
                await axios.post('https://api.alquilacarbolivia.com/api/productos', data, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } else {
                await axios.put(`https://api.alquilacarbolivia.com/api/productos/${editId}`, data, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            }

            Swal.fire({ icon: 'success', title: '¡Éxito!', text: 'Producto guardado correctamente', confirmButtonColor: '#10b981' });
            setShowModal(false);
            resetForm();
            fetchProductos();
        } catch (error) { 
            Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo procesar la solicitud', confirmButtonColor: '#ef4444' });
        }
    };

    const resetForm = () => {
        setFormData({ nombre: '', descripcion: '', precio: '', imagen: null });
        setImagePreview(null);
        setModalMode('add');
        setEditId(null);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({...formData, imagen: file});
            const reader = new FileReader();
            reader.onloadend = () => setImagePreview(reader.result);
            reader.readAsDataURL(file);
        }
    };

    // --- RECETAS ---
    const abrirReceta = async (prod) => {
        setSelectedProd(prod);
        try {
            const res = await axios.get(`https://api.alquilacarbolivia.com/api/recetas/${prod.id}`);
            setRecetaItems(res.data);
            setShowReceta(true);
        } catch (error) { console.error(error); }
    };

    const addIngrediente = async () => {
        if(!ingredienteForm.insumo_id || !ingredienteForm.cantidad) return;
        try {
            await axios.post('https://api.alquilacarbolivia.com/api/recetas', {
                producto_id: selectedProd.id,
                insumo_id: ingredienteForm.insumo_id,
                cantidad: ingredienteForm.cantidad
            });
            const res = await axios.get(`https://api.alquilacarbolivia.com/api/recetas/${selectedProd.id}`);
            setRecetaItems(res.data);
            setIngredienteForm({ insumo_id: '', cantidad: '' });
        } catch (error) { console.error(error); }
    };

    const deleteIngrediente = async (id) => {
        const result = await Swal.fire({ title: '¿Eliminar?', icon: 'warning', showCancelButton: true, confirmButtonColor: '#ef4444' });
        if (result.isConfirmed) {
            try {
                await axios.delete(`https://api.alquilacarbolivia.com/api/recetas/${id}`);
                const res = await axios.get(`https://api.alquilacarbolivia.com/api/recetas/${selectedProd.id}`);
                setRecetaItems(res.data);
            } catch (error) { console.error(error); }
        }
    };

    const handleDeleteProducto = async (id) => {
        const result = await Swal.fire({ title: '¿Eliminar producto?', text: 'Esta acción no se puede deshacer', icon: 'warning', showCancelButton: true, confirmButtonColor: '#ef4444' });
        if (result.isConfirmed) {
            await axios.delete(`https://api.alquilacarbolivia.com/api/productos/${id}`);
            fetchProductos();
            Swal.fire('Eliminado', '', 'success');
        }
    };

    return (
        <div className="container-fluid p-0" style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            {/* Header Mantenido */}
            <div style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '1.5rem 2rem',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}>
                <div className="d-flex align-items-center justify-content-between text-white">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-light shadow-sm" onClick={goBack} style={{ borderRadius: '12px' }}><FaArrowLeft/> Volver</button>
                        <h3 className="m-0 fw-bold"><FaUtensils/> Menú y Productos</h3>
                    </div>
                    <button className="btn btn-light shadow-lg fw-bold" onClick={() => { resetForm(); setShowModal(true); }}
                        style={{ borderRadius: '12px', padding: '0.75rem 1.5rem', background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)', border: 'none', color: '#fff' }}>
                        <FaPlus/> Nuevo Plato
                    </button>
                </div>
            </div>

            <div className="p-4">
                <div className="row g-4">
                    {productos.map((prod) => (
                        <div key={prod.id} className="col-lg-3 col-md-4 col-sm-6">
                            <div className="card h-100 border-0 shadow-sm" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                                <div style={{ height: '180px', background: '#eee', position: 'relative' }}>
                                    {prod.imagen_url ? (
                                        <img src={prod.imagen_url} style={{ width:'100%', height:'100%', objectFit:'cover' }} alt=""/>
                                    ) : (
                                        <div className="d-flex h-100 align-items-center justify-content-center text-muted opacity-30"><FaUtensils size={40}/></div>
                                    )}
                                    <div style={{ position: 'absolute', top: '12px', right: '12px', background: 'rgba(255, 255, 255, 0.9)', padding: '0.4rem 0.8rem', borderRadius: '20px', fontWeight: 'bold', color: '#667eea' }}>
                                        Bs. {parseFloat(prod.precio).toFixed(2)}
                                    </div>
                                </div>

                                <div className="card-body p-3">
                                    <h6 className="fw-bold mb-1 text-truncate">{prod.nombre}</h6>
                                    <p className="text-muted small mb-0 text-truncate">{prod.descripcion}</p>
                                </div>

                                <div className="card-footer bg-white border-top p-3 d-flex gap-2">
                                    <button className="btn btn-sm flex-fill fw-bold" onClick={() => abrirReceta(prod)}
                                        style={{ background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)', border: 'none', color: 'white', borderRadius: '8px' }}>
                                        <FaListUl/> Receta
                                    </button>
                                    {/* BOTÓN EDITAR AGREGADO */}
                                    <button className="btn btn-sm btn-outline-warning" onClick={() => handleEditClick(prod)} style={{ borderRadius: '8px' }}>
                                        <FaEdit/>
                                    </button>
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDeleteProducto(prod.id)} style={{ borderRadius: '8px' }}>
                                        <FaTrash/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* MODAL EDITAR / CREAR */}
            {showModal && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px' }}>
                            <div className="modal-header border-0 pb-0">
                                <h5 className="fw-bold">{modalMode === 'add' ? 'Nuevo Plato' : 'Editar Plato'}</h5>
                                <button className="btn-close" onClick={() => setShowModal(false)}></button>
                            </div>
                            <form onSubmit={handleSaveProducto}>
                                <div className="modal-body">
                                    <div className="text-center mb-3">
                                        <label className="btn btn-outline-secondary w-100 p-3 border-dashed" style={{ height: '140px', overflow:'hidden' }}>
                                            {imagePreview ? <img src={imagePreview} className="h-100 object-fit-cover rounded" alt=""/> : <><FaImage size={30}/><br/>Subir Foto</>}
                                            <input type="file" hidden accept="image/*" onChange={handleImageChange} />
                                        </label>
                                    </div>
                                    <input className="form-control mb-3" placeholder="Nombre del plato" required value={formData.nombre} onChange={e => setFormData({...formData, nombre: e.target.value})} />
                                    <input className="form-control mb-3" placeholder="Precio Bs" type="number" step="0.5" required value={formData.precio} onChange={e => setFormData({...formData, precio: e.target.value})} />
                                    <textarea className="form-control" placeholder="Descripción" rows="2" value={formData.descripcion} onChange={e => setFormData({...formData, descripcion: e.target.value})} />
                                </div>
                                <div className="modal-footer border-0">
                                    <button type="submit" className="btn btn-primary w-100 fw-bold py-2 rounded-pill"><FaCheckCircle/> GUARDAR</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL RECETAS - MANTENER IGUAL */}
            {showReceta && selectedProd && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '20px' }}>
                            <div className="modal-header"><h5 className="fw-bold">Receta: {selectedProd.nombre}</h5><button className="btn-close" onClick={() => setShowReceta(false)}></button></div>
                            <div className="modal-body">
                                <div className="row g-2 mb-4">
                                    <div className="col-6"><select className="form-select" value={ingredienteForm.insumo_id} onChange={e => setIngredienteForm({...ingredienteForm, insumo_id: e.target.value})}><option value="">Seleccionar Insumo...</option>{insumos.map(i => (<option key={i.id} value={i.id}>{i.nombre_insumo}</option>))}</select></div>
                                    <div className="col-4"><input className="form-control" placeholder="Cantidad" type="number" value={ingredienteForm.cantidad} onChange={e => setIngredienteForm({...ingredienteForm, cantidad: e.target.value})} /></div>
                                    <div className="col-2"><button className="btn btn-success w-100" onClick={addIngrediente}><FaPlus/></button></div>
                                </div>
                                <div className="list-group">
                                    {recetaItems.map((r) => (
                                        <div key={r.id} className="list-group-item d-flex justify-content-between align-items-center">
                                            <span>{r.nombre_insumo} - {r.cantidad_requerida} {r.unidad_medida}</span>
                                            <button className="btn btn-sm btn-danger" onClick={() => deleteIngrediente(r.id)}><FaTrash/></button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}